import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const ProjectFilters = ({ 
  activeFilters, 
  onFilterChange, 
  onClearFilters, 
  searchQuery, 
  onSearchChange,
  projectCount 
}) => {
  const filterCategories = [
    {
      id: 'industry',
      label: 'Industry',
      icon: 'Building2',
      options: [
        { value: 'financial-services', label: 'Financial Services' },
        { value: 'healthcare', label: 'Healthcare' },
        { value: 'technology', label: 'Technology' },
        { value: 'retail', label: 'Retail & E-commerce' },
        { value: 'manufacturing', label: 'Manufacturing' },
        { value: 'education', label: 'Education' }
      ]
    },
    {
      id: 'projectType',
      label: 'Project Type',
      icon: 'Briefcase',
      options: [
        { value: 'digital-transformation', label: 'Digital Transformation' },
        { value: 'strategic-consulting', label: 'Strategic Consulting' },
        { value: 'creative-campaign', label: 'Creative Campaign' },
        { value: 'process-optimization', label: 'Process Optimization' },
        { value: 'technology-implementation', label: 'Technology Implementation' }
      ]
    },
    {
      id: 'outcome',
      label: 'Outcome Focus',
      icon: 'Target',
      options: [
        { value: 'revenue-growth', label: 'Revenue Growth' },
        { value: 'operational-efficiency', label: 'Operational Efficiency' },
        { value: 'market-expansion', label: 'Market Expansion' },
        { value: 'cost-reduction', label: 'Cost Reduction' },
        { value: 'customer-experience', label: 'Customer Experience' }
      ]
    }
  ];

  const handleFilterToggle = (category, value) => {
    const currentFilters = activeFilters[category] || [];
    const newFilters = currentFilters.includes(value)
      ? currentFilters.filter(f => f !== value)
      : [...currentFilters, value];
    
    onFilterChange(category, newFilters);
  };

  const getTotalActiveFilters = () => {
    return Object.values(activeFilters).reduce((total, filters) => total + filters.length, 0);
  };

  return (
    <div className="glass-morph bg-primary/20 backdrop-blur-md rounded-xl border border-white/10 p-6 space-y-6">
      {/* Search */}
      <div className="relative">
        <Icon
          name="Search"
          size={20}
          className="absolute left-3 top-1/2 transform -translate-y-1/2 text-slate-600"
        />
        <input
          type="text"
          placeholder="Search projects by name, technology, or challenge..."
          value={searchQuery}
          onChange={(e) => onSearchChange(e.target.value)}
          className="w-full pl-10 pr-4 py-3 bg-white/95 backdrop-blur-sm border border-gray-300 rounded-lg focus:ring-2 focus:ring-brand-cyan focus:border-brand-cyan text-slate-900 placeholder-slate-600"
        />
      </div>

      {/* Filter Categories */}
      {filterCategories.map((category) => (
        <div key={category.id} className="space-y-3">
          <div className="flex items-center space-x-2">
            <Icon name={category.icon} size={18} className="text-brand-cyan" />
            <h3 className="font-semibold text-slate-900">{category.label}</h3>
          </div>
          
          <div className="flex flex-wrap gap-2">
            {category.options.map((option) => {
              const isActive = activeFilters[category.id]?.includes(option.value);
              return (
                <button
                  key={option.value}
                  onClick={() => handleFilterToggle(category.id, option.value)}
                  className={`px-3 py-2 rounded-lg text-sm font-medium transition-all duration-200 ${
                    isActive
                      ? 'bg-brand-cyan text-white border border-brand-cyan shadow-sm'
                      : 'bg-white/90 text-slate-700 border border-gray-300 hover:bg-brand-cyan/10 hover:text-slate-900 hover:border-brand-cyan/50'
                  }`}
                >
                  {option.label}
                </button>
              );
            })}
          </div>
        </div>
      ))}

      {/* Filter Summary */}
      <div className="pt-4 border-t border-white/20">
        <div className="flex items-center justify-between">
          <div className="text-sm text-slate-700">
            {projectCount} projects found
            {getTotalActiveFilters() > 0 && (
              <span className="ml-2 px-2 py-1 bg-brand-cyan/20 text-brand-cyan border border-brand-cyan/30 rounded-full text-xs">
                {getTotalActiveFilters()} filters
              </span>
            )}
          </div>

          {getTotalActiveFilters() > 0 && (
            <Button
              variant="ghost"
              size="sm"
              onClick={onClearFilters}
              iconName="X"
              iconPosition="left"
              className="text-slate-600 hover:text-slate-900"
            >
              Clear All
            </Button>
          )}
        </div>
      </div>
    </div>
  );
};

export default ProjectFilters;